import { GUIA_LABELS } from '@utils/guiaLabels.js'

interface Props {
  decisao: string
  dicas?: number
  alertas?: number
  ferramenta?: boolean
  checklist?: number
}

/** Resumo da etapa: a decisão + o que a página já traz (dicas, alertas, ferramenta). */
export function PassoDecisaoBanner({
  decisao,
  dicas = 0,
  alertas = 0,
  ferramenta = false,
  checklist = 0,
}: Props) {
  const chips: string[] = []
  if (dicas > 0) chips.push(`${dicas} dica${dicas > 1 ? 's' : ''}`)
  if (alertas > 0) chips.push(`${alertas} alerta${alertas > 1 ? 's' : ''}`)
  if (ferramenta) chips.push('Ferramenta')
  if (checklist > 0) chips.push(`${checklist} ${checklist > 1 ? 'itens' : 'item'} de checklist`)

  return (
    <div className='cf3-decisao' role='note'>
      <p className='cf3-decisao__label'>{GUIA_LABELS.decisaoDestaEtapa}</p>
      <p className='cf3-decisao__text'>{decisao}</p>
      {chips.length > 0 && (
        <ul className='cf3-decisao__chips'>
          {chips.map((c) => (
            <li key={c}>{c}</li>
          ))}
        </ul>
      )}
    </div>
  )
}
